<h2 class="text--h3">{{ 'manureSubstances' | translate }}</h2>
@for (fertilizerTypeData of fertilizerDataByType; track fertilizerTypeData) {
  <div>
    @if (fertilizerTypeData !== undefined) {
      <h3 class="text--h5">
        {{ getFertilizerTypeName(fertilizerTypeData.fertilizerType) }}
      </h3>
      <div class="flex--row print-border-all">
        <div
          class="flex__child flex__child-1 table-header text--bold print-padding-vertical align-desktop-top align-print-center print-padding manureSubstance"
        >
          {{ 'manureSubstance' | translate }}
        </div>
        <div
          class="flex__child flex__child-1 table-header text--bold print-padding-vertical align-desktop-top align-print-center print-border-left print-padding periodName"
        >
          {{ 'period' | translate }}
        </div>
        <div
          class="flex__child flex__child-1 table-header text--bold print-padding-vertical align-desktop-top align-print-center print-border-left print-padding"
        >
          {{ 'soilType' | translate }}
        </div>
        <div
          class="flex__child flex__child-1 table-header text--bold print-padding-vertical align-desktop-top align-print-center print-border-left print-padding quantity"
        >
          {{ 'dosage' | translate }}
        </div>
        <div
          class="flex__child flex__child-1 table-header text--bold print-padding-vertical align-desktop-top align-print-center print-border-left print-padding"
        >
          {{ 'totalNitrogen' | translate }}
        </div>
        <div
          class="flex__child flex__child-1 table-header text--bold print-padding-vertical align-desktop-top align-print-center print-border-left print-padding"
        >
          {{ 'totalPhosphate' | translate }}
        </div>
      </div>
      @for (fertilizer of fertilizerTypeData.fertilizerData; track fertilizer) {
        <div class="avoid-page-break" data-test="fertilizers-overview">
          <div class="flex--row print-border-no-top">
            <div
              class="flex__child print-padding flex__child-1 flex--row text--left print-padding manureSubstance"
              data-test="fertilizers-overview__crop-aid-name"
            >
              {{ fertilizer.cropAidName }}
            </div>
            <div
              class="flex__child flex__child-1 flex--row text--center print-border-left print-padding periodName"
              data-test="fertilization-legal-standards-fertilizers-overview__sales-order-period-name"
            >
              @if (isAnimal(fertilizer.cropAidFertilizerType)) {
                <span>{{ fertilizer.salesOrderPeriodName }}</span>
              }
            </div>
            <div
              class="flex__child flex__child-1 flex--row text--center print-border-left print-padding"
              data-test="fertilizers-overview__soil-type-name"
            >
              {{ fertilizer.soilTypeName }}
            </div>
            <div
              class="flex__child flex__child-1 flex--row text--center print-border-left print-padding quantity"
              data-test="fertilizers-overview__dosage"
            >
              {{ fertilizer.dosage | agrNumber: '1.0-0' }}
            </div>
            <div
              class="flex__child flex__child-1 flex--row text--center print-border-left print-padding"
              data-test="fertilizers-overview__total-nitrogen"
            >
              {{ fertilizer.totalNitrogen | agrNumber: '1.0-0' }}
            </div>
            <div
              class="flex__child flex__child-1 flex--row text--center print-border-left print-padding"
              data-test="fertilizers-overview__total-phosphate"
            >
              {{ fertilizer.totalPhosphate | agrNumber: '1.0-0' }}
            </div>
          </div>
          @if (!!fertilizer.comment?.trim()) {
            <div class="flex--row print-border-no-top">
              <p
                class="flex__child print-padding flex__child-1 flex--row text--right print-padding spacing--padding-left text-color--info-400"
              >
                {{ fertilizer.comment }}
              </p>
            </div>
          }
        </div>
      }
    }
  </div>
}
